<div class="ops-vendor-management">
  <div class="container">
    <div class="dashboard-header">
      <div class="left-section">
        <h1>Vendor Management</h1>
      </div>
      <div class="right-section">
        <app-button-group
  *ngIf="false"
  [label]="'Quarterly Feedback'"
  [buttonType]="'Primary'"
  (onEmit)="navigateToQuarterlyFeedback()"
></app-button-group>
        <emerald-button
          [type]="'Primary'"
          [label]="'Vendors'"
          [size]="'Medium'"
          [icon]="'arrow_drop_down'"
          [iconFillType]="'filled'"
          (onClick)="toggleModal()"
          [iconPosition]="'Right'"
        ></emerald-button>
        <div
          class="dropdown-modal"
          *ngIf="isModalOpen"
          [style]="{
            position: 'absolute',
            top: '100%',
            right: '0',
            zIndex: '1000',
            marginTop: '1px',
          }">
            <ul class="dropdown-list" (click)="handleOptionClick($event)">
            <li *ngFor="let option of vendorOptions">{{ option }}</li>
            </ul>
        </div>
      </div>
    </div>

    <div class="dashboard">
      <div class="grid-layout">
        <div class="left-section">
          <div class="top-vendors">
            <app-ops-top-vendors></app-ops-top-vendors>
          </div>
          <div class="bottom-left"><app-ops-contractor-head-count></app-ops-contractor-head-count></div>
        </div>
        <div class="right-section">
          <app-ops-timesheet-trends></app-ops-timesheet-trends>
          <app-msa-expiry *ngIf="showMsaExpiry"></app-msa-expiry>
        </div>
      </div>
      <div class="bottom">
        <app-ops-open-positions></app-ops-open-positions>
      </div>
    </div>
  </div>
  <div class="modal-overlay" *ngIf="selectedAction === 'invite-vendor'">
    <div class="modal-content">
      <app-invite-form
        *ngIf="openForm"
        (close)="onInviteFormClose()"
      ></app-invite-form>
      <button class="modal-close" (click)="selectedAction = null">
        &times;
      </button>
    </div>
  </div>
</div>
